import request from '@/utils/request'

export function login(data) {
    return request({
        url: '/api/auth/login',
        method: 'post',
        data
    })
}

export function logout() {
    return request({
        url: '/logout',
        method: 'post'
    })
}

export function user_Info() {
    return request({
        url: '/user/info',
        method: 'get'
    })
}
///api/v2/user
export function userInfo() {
    return request({
        url: '/api/v2/user',
        method: 'get'
    })
}
export function userInfo1() {
    return request({
        url: '/api/v1/user',
        method: 'post'
    })
}
///api/v2/user
export function setuserInfo(data) {
    return request({
        url: '/api/v2/user',
        method: 'post',
        data
    })
}
export function legal(data) {
    return request({
        url: `/api/v1/legal`,
        method: 'post',
        data
    })
}
///api/v1/invoice
export function invoice(data) {
    return request({
        url: `/api/v1/invoice`,
        method: 'post',
        data
    })
}
///api/v1/user
export function setuser(data) {
    return request({
        url: `/api/v1/user`,
        method: 'put',
        data
    })
}
///api/v1/invoice
export function setinvoice(data) {
    return request({
        url: `/api/v1/invoice`,
        method: 'put',
        data
    })
}
export function setlegal(data) {
    return request({
        url: `/api/v1/legal`,
        method: 'put',
        data
    })
}

///api/cooper/authCode64
export function authCode64(data) {
    return request({
        url: `/api/cooper/authCode64`,
        method: 'get',
        data
    })
}
export function cooper(data) {
    return request({
        url: `/api/cooper`,
        method: 'post',
        data
    })
}
//portal-api/index/get-data
export function indexget(data) {
    return request({
        url: `/portal-api/index/get-data`,
        method: 'get',
        data
    })
}
//admin-api/elg/auth/get-token
export function gettoken(data) {
    return request({
        url: `/admin-api/fscg/auth/get-token`,
        method: 'post',
        data
    })
}
//admin-api/elg/auth/get-user-info
export function gettuserInfo(params) {
    return request({
        url: `/admin-api/fscg/auth/get-user-info`,
        method: 'get',
        params
    })
}
//portal-api/index/get-guarantee-type
export function getguarantee(params) {
    return request({
        url: `/portal-api/index/get-guarantee-type`,
        method: 'get',
        params
    })
}
//portal-api/index/get-credit-category
export function getcategory(params) {
    return request({
        url: `/portal-api/index/get-credit-category`,
        method: 'get',
        params
    })
}
//portal-api/index/get-infos
export function getinfos(params) {
    return request({
        url: `/portal-api/index/get-infos`,
        method: 'get',
        params
    })
}
//portal-api/guarantee/get-type
export function getguaranteetype(params) {
    return request({
        url: `/portal-api/guarantee/get-type`,
        method: 'get',
        params
    })
}
//portal-api/guarantee/get-category
export function getgcategory(params) {
    return request({
        url: `/portal-api/guarantee/get-category`,
        method: 'get',
        params
    })
}
//portal-api/credit/get-category
export function getgcreditcategory(params) {
    return request({
        url: `/portal-api/credit/get-category`,
        method: 'get',
        params
    })
}
//portal-api/information/get-types
export function informationtypes(params) {
    return request({
        // url: `/portal-api/information/get-types`,
        url: `/portal-api/information/getTypeList`,
        method: 'get',
        params
    })
}
//portal-api/information/page
export function informationpage(params) {
    return request({
        url: `/portal-api/information/page`,
        method: 'get',
        params
    })
}
//portal-api/information/get
export function informationget(params) {
    return request({
        url: `/portal-api/information/get`,
        method: 'get',
        params
    })
}
//portal-api/guarantee-check/get-type
export function iguaranteegettype(params) {
    return request({
        url: `/portal-api/guarantee-check/get-type`,
        method: 'get',
        params
    })
}
//portal-api/guarantee-check/get-category
export function guaranteegetcategory(params) {
    return request({
        url: `/portal-api/guarantee-check/get-category`,
        method: 'get',
        params
    })
}
//portal-api/guarantee-check/get-captcha
export function guaranteegetcaptcha(params) {
    return request({
        url: `/portal-api/guarantee-check/get-captcha`,
        method: 'get',
        params
    })
}
//portal-api/guarantee-check/check-guarantee-info
export function guaranteeinfo(params) {
    return request({
        url: `/portal-api/guarantee-check/get-guarantee-detail`,
        method: 'get',
        params
    })
}
///portal-api/index/indexAccess

export function getOrgImgs(params) {
    return request({
        url: `/portal-api/index/getOrgImgs`,
        method: 'get',
        params
    })
}
export function indexAccess(params) {
    return request({
        url: `/portal-api/index/indexAccess`,
        method: 'get',
        params
    })
}
///portal-api/index/indexCenterInfo
export function indexCenterInfo(params) {
    return request({
        url: `/portal-api/index/indexCenterInfo`,
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/api/user.js